// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-icon[data-v-1e22315f]{transition:.4s;cursor:pointer}.copy-icon[data-v-1e22315f]:hover{color:#cdcdcd}", ""]);
// Exports
module.exports = exports;
